import { all } from 'redux-saga/effects';
import consentSaga from './consent/consentSaga';
import initializeSaga from './initializeApp';
import getInviteInfoSaga from './invites/getInviteInfo';
import loginSaga from './loginAndRegister/loginSaga';
import logOutSaga from './loginAndRegister/logoutSaga';
import passwordSaga from './loginAndRegister/passwordSaga';
import registerSaga from './loginAndRegister/registerSaga';
import ssoSaga from './ssoSaga';

export default function* sagas(): Generator {
    yield all([
        consentSaga(),
        getInviteInfoSaga(),
        initializeSaga(),
        loginSaga(),
        logOutSaga(),
        passwordSaga(),
        registerSaga(),
        ssoSaga(),
    ]);
}
